import { VerifiedOutlined } from '@mui/icons-material';
import { InfoTooltip } from '@side/pantry';

export function BothSideAgentsIndicator() {
  return (
    <InfoTooltip
      icon={<VerifiedOutlined sx={{ color: 'secondary.dark', fontSize: 16 }} />}
      iconButtonSx={{
        padding: 0,
      }}
      // Prevent the table row click from navigating when the icon is tapped
      onClick={(event) => event.preventDefault()}
      title="Both agents are Side App users"
    />
  );
}
